import React, { Component, Suspense, useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Routes, json } from "react-router-dom";
import "./scss/style.scss";
import performClientHandshake from "./api/clientHandShake";
// import "../src/views/dashboard/App.css"
import { Toaster } from 'react-hot-toast'

import { RequireAuth } from "react-auth-kit";
import { useLocation, useNavigate } from "react-router-dom";
const loading = (
  <div className="pt-3 text-center">
    {" "}
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));



// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const ForgotPassword = React.lazy(() =>
  import("./views/pages/ForgotPassword/forgotPassword")
);
const ResetPassword = React.lazy(() =>
  import("./views/pages/ForgotPassword/resetPassword")
);

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const initializeApp = async () => {
      try {
        if (isMounted) {
          await performClientHandshake();
        }
      } catch (error) {
        console.error("Error during client handshake:", error);
      }
    };

    initializeApp();

    return () => {
      isMounted = false;
    };
  }, [location.pathname, navigate]);

  return (
    <Suspense fallback={loading}>

      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      

      <Routes>
        <Route exact path="/login" name="Login Page" element={<Login />} />
        <Route
          exact
          path="/register"
          name="Register Page"
          element={<Register />}
        />
        <Route exact path="/404" name="Page 404" element={<Page404 />} />
        <Route exact path="/500" name="Page 500" element={<Page500 />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route
          exact
          path="*"
          element={
            <RequireAuth loginPath="/login">
              <DefaultLayout />
            </RequireAuth>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default App
